import { render, staticRenderFns } from "./Sqs.vue?vue&type=template&id=6d17e241&scoped=true"
import script from "./Sqs.vue?vue&type=script&lang=ts"
export * from "./Sqs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d17e241",
  null
  
)

export default component.exports